import ShModel from './sh-model';
import { belongsTo, hasMany, attr } from '@ember-data/model';

const PROCESSORS = {
  INVOICE: 'invoice',
  STRIPE: 'stripe',
};

export const SH_GENERAL_INVOICE = {
  PROCESSORS,
};

export default class ShGeneralInvoice extends ShModel {
  @attr('string') memo;
  @attr('number') amountInCents;
  @attr('number') paidAmountInCents;
  @attr('number') relatedId;

  @attr('date') createdAt;
  @attr('date') paidAt;
  @attr('date') deletedAt;

  @hasMany('shGeneralInvoiceTransactions', { async: false }) shGeneralInvoiceTransactions;
  @belongsTo('shModel', { async: false, polymorphic: true}) related;

  get isPaid() {
    return !!this.paidAt;
  }

  get amountUnpaidInCents() {
    return this.amountInCents - this.paidAmountInCents;
  }
}
